import React from 'react';
import { Star } from 'lucide-react';

interface RatingStarsProps {
  rating: number;
  hoveredRating: number | null;
  onRatingClick: (rating: number) => void;
  onRatingHover: (rating: number | null) => void;
  color: string;
  size?: number;
  disabled?: boolean;
}

export const RatingStars: React.FC<RatingStarsProps> = ({
  rating,
  hoveredRating,
  onRatingClick,
  onRatingHover,
  color,
  size = 32,
  disabled = false
}) => {
  return (
    <div className="flex items-center">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => !disabled && onRatingClick(star)}
          onMouseEnter={() => !disabled && onRatingHover(star)}
          onMouseLeave={() => !disabled && onRatingHover(null)}
          className={`p-1 focus:outline-none ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
          disabled={disabled}
        >
          <Star
            size={size}
            fill={(hoveredRating !== null ? star <= hoveredRating : star <= rating) ? color : 'none'}
            stroke={color}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
};

export default RatingStars;